import { Component, Prop, Vue } from 'vue-property-decorator';

import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import IReceipt from '@/interfaces/IReceipt';
import capitalizeFirstLetter from '@/libs/capitalizeFirstLetter';
import dateToStandart from '@/libs/date/dateToStandart';

@Component({
    name: 'ReceiptForm',
    components: {
        CardHeader
    }
})
export default class ReceiptForm extends Vue {
    @Prop(Object) private formData!: IReceipt;

    public transformValue(field:string, value:any):string {
        switch (field) {
            case 'purchaseDate':
                return dateToStandart(value);
            case 'expiresDate':
                return dateToStandart(value);
            case 'cancellationDate':
                return dateToStandart(value);
            case 'originalPurchaseDate':
                return dateToStandart(value);
            case 'subscriptionCreatedAt':
                return dateToStandart(value);
            default:
                return value ? String(value): '–';
        }
    }

    public transformLabel(nameField: string): string {
        return capitalizeFirstLetter(nameField);
    }

}
